<era-master-detail flexGrowLeft="2"
                   flexGrowRight="1"
                   [isH2]="false">
  <era-master>
    <era-panel>
      <div class="px-3">
        <era-devices-unavailable></era-devices-unavailable>
      </div>
    </era-panel>
  </era-master>
</era-master-detail>